import actionTypes from '../constants/action-types';

const removeLocale = (locale, resolve, reject) => ({
  type: actionTypes.REMOVE_LOCALE,
  payload: { locale, resolve, reject },
});

export default removeLocale;
